import { useEffect, useState } from 'react';

const UseAlone = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [message, setMessage] = useState('');
    const [leakedData, setLeakedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const dataPerPage = 50;
    const [totalPages, setTotalPages] = useState(0);
    
    const [filters, setFilters] = useState({
        mkr_sku:'',
        name: '', 
        brand: ''
    });
    const [lengths, setLengths] = useState({
        dataLength: 0,
        leakedLength: 0
    });

    useEffect(() => {
        const config = {
            method: 'GET',
            headers: {
                Authorization: `Token ${localStorage.getItem('token')}`,    
            }
        }
        if(isLoading){
            setIsLoading(false);
            fetch("https://api.gestor.mkr.cl/codes/", config)
                .then(response => {
                    response.json()
                    .then(data => {
                        setData(data);
                        setLeakedData(data);
                        setLengths({
                            dataLength: data.length,
                            leakedLength: data.length
                        });
                        setTotalPages(Math.ceil(data.length / dataPerPage));
                    })
                })
            .catch(err => {
                setIsLoading(true);
                console.log(err)
            })
        }
    }, [isLoading]);

    
    const handleFilterInput = (e) => {
        const {name, value} = e.target;
        setFilters({
            ...filters,
            [name]: value
        });
    } 
    const cleanString = (str) => {
        var clean = str.toUpperCase();
        clean = clean.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        clean = clean.replace(/[^a-zA-Z0-9\s]+/g, "");
        clean = clean.split(" ");
        return clean;
    }
    const compareStrings = (arr1, arr2) => {
        var bool = false
        arr1.forEach((str) => {
            arr2.forEach((str2) => {
                if(str2.includes(str) === true){
                    bool = true;
                }
            })
        });
        return bool;
    }

    const handleFilterSubmit = (e) => {
        console.log(data);
        const {name, value} = e.target;
        if(e.key==="Enter") {
            var arr = [];
            var cleanValue = cleanString(value);
            if(name==="mkr_sku") {
                if(value === '') {
                    setLeakedData(data);
                    setTotalPages(Math.ceil(data.length / dataPerPage));
                } else {
                    data.forEach(element  => {
                        var cleanElement = cleanString(element.mkr_code);
                        if(compareStrings(cleanValue, cleanElement) === true) {
                            arr.push(element);
                        }
                    });
                    setLeakedData(arr);
                    setTotalPages(Math.ceil(arr.length / dataPerPage));
                    setLengths({
                        ...lengths,
                        leakedLength: arr.length
                    });
                    setFilters({
                        ...filters,
                        [name]: ''
                    });
                }
            }
            if(name==="name") {
                if(value === '') {
                    setLeakedData(data);
                    setTotalPages(Math.ceil(data.length / dataPerPage));
                } else {
                    data.forEach(element  => {
                        var cleanElement = cleanString(element.name);
                        if(compareStrings(cleanValue, cleanElement) === true) {
                            arr.push(element);
                        }
                    });
                    setLeakedData(arr);
                    setTotalPages(Math.ceil(arr.length / dataPerPage));
                    setLengths({
                        ...lengths,
                        leakedLength: arr.length
                    });
                    setFilters({
                        ...filters,
                        [name]: ''
                    });
                }
            }
            if(name==="brand") {
                if(value === '') {
                    setLeakedData(data);
                    setTotalPages(Math.ceil(data.length / dataPerPage));
                } else {
                    data.forEach(element  => {
                        var cleanElement = cleanString(element.brand);
                        if(compareStrings(cleanValue, cleanElement) === true) {
                            arr.push(element);
                        }
                    });
                    setLeakedData(arr);
                    setTotalPages(Math.ceil(arr.length / dataPerPage));
                    setLengths({
                        ...lengths,
                        leakedLength: arr.length
                    });
                    setFilters({
                        ...filters,
                        [name]: ''
                    });
                }
            }
            
        } 
    }

    const paginate = (number) => {
        setCurrentPage(number);
    } 

    const filtersOff = () => {
        setFilters({
            name: '', 
            brand: '',
            mkr_sku: ''
        });
        setLeakedData(data);
        setTotalPages(Math.ceil(data.length / dataPerPage));
        setLengths({
            ...lengths,
            leakedLength: data.length
        });
    }
   
    return {lengths, filters, leakedData, isOpen, message, totalPages, currentPage, paginate, handleFilterInput, handleFilterSubmit,filtersOff, setIsOpen};
}

export default UseAlone;
